import { ComponentProps } from 'react';

import { FormSelectField } from '@sbv-clients/ui-forms';

type FormatFieldProps = ComponentProps<typeof FormSelectField>;

const options = [
  { id: '0', label: 'Portrait', value: '0' },
  { id: '1', label: 'Landscape', value: '1' },
];

export const OrientationFormField = (props: FormatFieldProps) => {
  return <FormSelectField {...props} options={options} size="small" />;
};
